<template>
	<div>
		<div class="box mt-10">
			<md-card>
				<md-card-expand>
			        <md-card-actions md-alignment="space-between">
			        	<md-card-expand-trigger>
			        		<md-button class="community-expand-button m-left-5"><div @click="expandchannel('8')">Content</div></md-button>
          				</md-card-expand-trigger>
          			</md-card-actions>
      				<md-card-expand-content>
						<md-card-content class="card-content">
							<div :class="{ opened: opened.includes('8') }" v-show="opened.includes('8')">
								<form @submit.prevent="addContent('form-content')" @change="saveContentText='save'" data-vv-scope="form-content">
							    	<md-field class="create-community m-left-5">
										<label class="card-header">Thank you page</label>
										<md-input v-model.lazy="content.thankYouURL" name="thank you" placeholder="Thank You URL" @input = "content.thankYouURL = sanitizeURL($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.thank you')">{{errors.first('form-content.thank you')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Landing page</label>
										<md-input v-model.lazy="content.landingPageURL" name="landing page" placeholder="Landing Page URL" @input = "content.landingPageURL = sanitizeURL($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.landing page')">{{errors.first('form-content.landing page')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Terms & Conditions URL</label>
										<md-input v-model.lazy="content.termsConditionsURL" name="terms condition" placeholder="Terms & Conditions URL" @input = "content.termsConditionsURL = sanitizeURL($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.terms condition')">{{errors.first('form-content.terms condition')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Frequently Asked Questions</label>
										<md-input v-model.lazy="content.frequentlyAskQuestionsURL" name="frequently ask" placeholder="Frequently Asked Questions URL" @input = "content.frequentlyAskQuestionsURL = sanitizeURL($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.frequently ask')">{{errors.first('form-content.frequently ask')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Tips & Best Practices</label>
										<md-input v-model.lazy="content.tips" name="tips" placeholder="Tips & Best Practices" @input = "content.tips = sanitizeURL($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.unsubscribePageURL')">{{errors.first('form-content.unsubscribePageURL')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Unsubscribe Page URL</label>
										<md-input class="not-allowed" v-model.lazy="content.unsubscribePageURL" name="unsubscribe page" readonly="" placeholder="Unsubscribe Page URL" @input = "content.unsubscribePageURL = sanitizeURL($event)"></md-input>
									</md-field>
									<hr class="dark-border m-left-5" />
									<md-field class="create-community m-left-5">
										<label class="card-header">Parameter 1: Member Affinity Name ("Blue Devil")</label>
										<md-input v-model.lazy="content.parameter1" v-validate.continues="'max:100'" :maxlength="maxParameters" name="parameter1" placeholder='Parameter 1: Member Affinity Name ("Blue Devil")' @input = "content.parameter1 = sanitizeInput($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.parameter1')">{{errors.first('form-content.parameter1')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Parameter 2: Community Name ("Ask A Blue Devil")</label>
										<md-input v-model.lazy="content.parameter2" v-validate.continues="'max:100'" :maxlength="maxParameters" name="parameter2" placeholder='Parameter 2: Community Name ("Ask A Blue Devil")' @input = "content.parameter2 = sanitizeInput($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.parameter2')">{{errors.first('form-content.parameter2')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Parameter 3: Member Affinity Name ("a fellow Blue Devil")</label>
										<md-input v-model.lazy="content.parameter3" v-validate.continues="'max:100'" :maxlength="maxParameters" name="parameter3" placeholder='Parameter 3: Member Affinity Name ("a fellow Blue Devil")' @input = "content.parameter3 = sanitizeInput($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.parameter3')">{{errors.first('form-content.parameter3')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Parameter 4: Organization Name ("Duke")</label>
										<md-input v-model.lazy="content.parameter4" v-validate.continues="'max:100'" :maxlength="maxParameters" name="parameter4" placeholder='Parameter 4: Organization Name ("Duke")' @input = "content.parameter4 = sanitizeInput($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.parameter4')">{{errors.first('form-content.parameter4')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Parameter 5: Member Name ("student")</label>
										<md-input v-model.lazy="content.parameter5" v-validate.continues="'max:100'" :maxlength="maxParameters" name="parameter5" placeholder='Parameter 5: Member Name ("student")' @input = "content.parameter5 = sanitizeInput($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.parameter5')">{{errors.first('form-content.parameter5')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Parameter 6: Advisor Name ("alum")</label>
										<md-input v-model.lazy="content.parameter6" v-validate.continues="'max:100'" :maxlength="maxParameters" name="parameter6" placeholder='Parameter 6: Advisor Name ("alum")' @input = "content.parameter6 = sanitizeInput($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.parameter6')">{{errors.first('form-content.parameter6')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Parameter 7</label>
										<md-input v-model.lazy="content.parameter7" v-validate.continues="'max:100'" :maxlength="maxParameters" name="parameter7" placeholder="Parameter 7" @input = "content.parameter7 = sanitizeInput($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.parameter7')">{{errors.first('form-content.parameter7')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Parameter 8</label>
										<md-input v-model.lazy="content.parameter8" v-validate.continues="'max:100'" :maxlength="maxParameters" name="parameter8" placeholder="Parameter 8" @input = "content.parameter8 = sanitizeInput($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.parameter8')">{{errors.first('form-content.parameter8')}}</p>
									<hr class="dark-border m-left-5" />
									<md-field class="create-community m-left-5">
										<label class="card-header">Response Engagement Tips</label>
										<md-input v-model.lazy="content.responseEngagementTip" v-validate="{ required: false, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }" name="responseEngagementTip" placeholder="Response Engagement Tips" @input = "content.responseEngagementTip = sanitizeURL($event)"></md-input>
										<span class="md-helper-text"><strong>Note:</strong> Response engagement tip URL for i.e https://www.example.com</span>
									</md-field>
									<p class="error m-left-5 m-top-20" v-if="errors.has('form-content.responseEngagementTip')">{{errors.first('form-content.responseEngagementTip')}}</p>
									<md-field>
										<label>Welcome Adviser</label>
										<md-textarea v-model.lazy="content.welcomeadviser" @blur="content.welcomeadviser = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="welcomeadviser" placeholder="Welcome Adviser"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.welcomeadviser')">{{errors.first('form-content.welcomeadviser')}}</p>
									<md-field>
										<label>Welcome Member</label>
										<md-textarea v-model.lazy="content.welcomemember" @blur="content.welcomemember = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="welcomemember" placeholder="Welcome member"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.welcomemember')">{{errors.first('form-content.welcomemember')}}</p>
									<md-field>
										<label>Referral Message</label>
										<md-textarea v-model.lazy="content.referralMessage" @blur="content.referralMessage = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'required|max:5000'" :maxlength="maxWelcome" name="referralMessage" placeholder="Referral Message"></md-textarea>
									</md-field>
									<p class="error m-left-5 error-custom-position" v-show="errors.has('form-content.referralMessage')">{{errors.first('form-content.referralMessage')}}</p>
									<md-field>
										<label>Request Form Wizard - Page 1</label>
										<md-textarea v-model.lazy="content.requestIntroduction" @blur="content.requestIntroduction = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="coach" placeholder="Request Form Wizard - Page 1"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.coach')">{{errors.first('form-content.coach')}}</p>
									<md-field>
										<label>Request Form Wizard - Page 2</label>
										<md-textarea v-model.lazy="content.requestFormWizardPage2" @blur="content.requestFormWizardPage2 = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="requestFormWizardPage2" placeholder="Request Form Wizard - Page 2"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.requestFormWizardPage2')">{{errors.first('form-content.requestFormWizardPage2')}}</p>
									<md-field>
										<label>Request Form Wizard - Page 3</label>
										<md-textarea v-model.lazy="content.requestFormWizardPage3" @blur="content.requestFormWizardPage3 = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="requestFormWizardPage3" placeholder="Request Form Wizard - Page 3"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.requestFormWizardPage3')">{{errors.first('form-content.requestFormWizardPage3')}}</p>
									<md-field class="create-rule">
										<label>Request Form Wizard - Page 4</label>
										<md-textarea v-model.lazy="content.requestPageThankYou" @blur="content.requestPageThankYou = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'required|max:5000'" :maxlength="maxWelcome" name="formThankyou" placeholder="Request Form Wizard - Page 4"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.formThankyou')">{{errors.first('form-content.formThankyou')}}</p>
									<md-field>
										<label>Request Coaching Message</label>
										<md-textarea v-model.lazy="content.coach" @blur="content.coach = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="coach" placeholder="Request Coaching Message"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.coach')">{{errors.first('form-content.coach')}}</p>
									<md-field>
										<label>Response Coaching Message</label>
										<md-textarea v-model.lazy="content.responseCoach" @blur="content.responseCoach = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="responseCoach" placeholder="Response Coaching Message"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.responseCoach')">{{errors.first('form-content.responseCoach')}}</p>
									<md-field>
										<label>Action Form - Advice Tips</label>
										<md-textarea v-model.lazy="content.actionFormAdviceTips" @blur="content.actionFormAdviceTips = sanitizeActionFormTips($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="actionFormAdviceTips" placeholder="Action Form - Advice Tips"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.actionFormAdviceTips')">{{errors.first('form-content.actionFormAdviceTips')}}</p>
									<md-field>
										<label>Action Form - Call Tips</label>
										<md-textarea v-model.lazy="content.actionFormCallTips" @blur="content.actionFormCallTips = sanitizeActionFormTips($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="actionFormCallTips" placeholder="Action Form - Call Tips"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.actionFormCallTips')">{{errors.first('form-content.actionFormCallTips')}}</p>
									<md-field>
										<label>Action Form - Meeting Tips</label>
										<md-textarea v-model.lazy="content.actionFormMeetingTips" @blur="content.actionFormMeetingTips = sanitizeActionFormTips($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="actionFormMeetingTips" placeholder="Action Form - Meeting Tips"></md-textarea>
									</md-field>
<p class="error m-left-5" v-show="errors.has('form-content.actionFormMeetingTips')">{{errors.first('form-content.actionFormMeetingTips')}}</p>
									<md-field>
										<label>Request Form Confirmation</label>
										<md-textarea v-model.lazy="content.formConfirmation" @blur="content.formConfirmation = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="formConfirmation" placeholder="Request Form Confirmation"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.formConfirmation')">{{errors.first('form-content.formConfirmation')}}</p>
									<md-field class="create-rule">
										<label>Feedback Request Message</label>
										<md-textarea v-model.lazy="content.feedbackRequestMessage" @blur="content.feedbackRequestMessage = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="formFeedbackRequestMessage" placeholder="Feedback Request Message"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.formFeedbackRequestMessage')">{{errors.first('form-content.formFeedbackRequestMessage')}}</p>
									<md-field class="create-rule">
										<label>Donor Alert Introduction</label>
										<md-textarea v-model.lazy="content.donorAlertMessage" @blur="content.donorAlertMessage = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="donorAlertMessage" placeholder="Donor Alert Message"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.donorAlertMessage')">{{errors.first('form-content.donorAlertMessage')}}</p>
									<p>
										<md-checkbox v-model="content.termsAndConditions">Require Terms & Conditions acceptance from advisors</md-checkbox>
									</p>
									<md-field class="create-rule">
										<label>Terms & Conditions</label>
										<md-textarea v-model.lazy="content.termsAndConditionsMessage" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="formTermsAndConditionsMessage" placeholder="Terms & Conditions" @blur="content.termsAndConditionsMessage = sanitizeHtmlTemplate($event.target.value)"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.formTermsAndConditionsMessage')">{{errors.first('form-content.formTermsAndConditionsMessage')}}</p>
									<p>
										<label>Testimonial Consent</label>
										<md-checkbox v-model="content.testimonialConsent" name="testimonialConsent"></md-checkbox>
									</p>
									<md-field>
										<label>Testimonial Consent Message</label>
										<md-textarea v-model="content.testimonialConsentMessage" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="testimonialConsentMessage" placeholder="Testimonial Consent Message" @blur="content.testimonialConsentMessage = sanitizeHtmlTemplate($event.target.value)"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.testimonialConsentMessage')">{{errors.first('form-content.testimonialConsentMessage')}}</p>


									<md-field class="create-rule">
										<label>Closed Request Message</label>
										<md-textarea v-model.lazy="content.closeRequestMessage" @blur="content.closeRequestMessage = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'required|max:5000'" :maxlength="maxWelcome" name="closeRequestMessage" placeholder="Close Request Message"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.closeRequestMessage')">{{errors.first('form-content.closeRequestMessage')}}</p>
									<md-field class="create-rule">
										<label>Message on Snooze page</label>
										<md-textarea v-model.lazy="content.snoozeMessage" @blur="content.snoozeMessage = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'required|max:5000'" :maxlength="maxWelcome" name="snoozeMessage" placeholder="Message on Snooze page"></md-textarea>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.snoozeMessage')">{{errors.first('form-content.snoozeMessage')}}</p>
									<md-field class="create-rule">
										<label>Resources</label>
										<md-textarea v-model.lazy="content.resources" @blur="content.resources = sanitizeHtmlTemplate($event.target.value)" v-validate.continues="'max:5000'" :maxlength="maxWelcome" name="resources" placeholder="Resources"></md-textarea>
									</md-field>
									<md-field class="create-community m-left-5">
										<label class="card-header">Member Thank You Page</label>
										<md-input v-model.lazy="content.memberThankYou" name="memberThankYou" placeholder="Member Thank You Page" v-validate="{ required: false, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }" @input = "content.memberThankYou = sanitizeURL($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.memberThankYou')">{{errors.first('form-content.memberThankYou')}}</p>
									<md-field class="create-community m-left-5">
										<label class="card-header">Advisor Thank You Page</label>
										<md-input v-model.lazy="content.advisorThankYou" name="advisorThankYou" placeholder="Advisor Thank You Page" v-validate="{ required: false, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }" @input = "content.advisorThankYou = sanitizeURL($event)"></md-input>
									</md-field>
									<p class="error m-left-5" v-show="errors.has('form-content.advisorThankYou')">{{errors.first('form-content.advisorThankYou')}}</p>
									<p>
										<md-checkbox v-model.lazy="content.profileValidation">Profile validation on Thank You page</md-checkbox>
									</p>
									<hr class="dark-border m-left-5 mt-40 mb-40">
									<h3 class="m-left-5 mb-20">Email Content</h3>
									<md-field class="create-community m-left-5">
										<label class="card-header">Email Footer (community.email_footer)</label>
										<md-textarea v-model.lazy="content.emailFooter" name="emailFooter" class="content-emailfooter" placeholder="Email Footer" :rows=20 @blur="content.emailFooter = sanitizeHtmlTemplate($event.target.value)"></md-textarea>
										<p class="error m-left-5" v-show="errors.has('form-content.emailFooter')">{{errors.first('form-content.emailFooter')}}</p>
									</md-field>
									<hr class="dark-border m-left-5 mt-40 mb-40">
									<h3 class="m-left-5 mb-20">Invalid Member Message</h3>
									<md-field class="create-community m-left-5">
										<label class="card-header">Invalid Member Message (community.email)</label>
										<md-textarea v-model.lazy="content.invalidMemberMessage" name="invalidMemberMessage" @blur="content.invalidMemberMessage = sanitizeHtmlTemplate($event.target.value), labelValidate('invalidMemberMessage')" class="content-invalidMemberMessage" placeholder="Invalid Member Message"></md-textarea>
									</md-field>
									<md-button class="md-raised md-round md-accent m-left-5" type="submit">{{ saveContentText }}</md-button>
								</form>
							</div>
						</md-card-content>
					</md-card-expand-content>
		    	</md-card-expand>
			</md-card>
		</div>
	</div>
</template>
<!-- Script-->
<script>
import API from "../../../services/API";
import { sanitizeInput, sanitizeUrl, sanitizeHtmlTemplate, sanitizeActionFormTips as applyActionFormTipsSanitize } from "../../../utils/sanitizer";

export default {
	props: ["content", "community_id", "labelValidate"],
	data() {
		return {
			api: new API(),
			community: {},
			active: false,
			opened: [],
			fullPage: true,
			requestForm: {
				subjectLine: 'Short summary ...',
				question: "I have a question about ..."
			},
			saveContentText: "save",
			maxParameters: 100,
			maxWelcome: 5000,
			feedbackRequestDefaultText: "We get great feedback on {{ community.parameter1 }} and we're trying to show just how helpful of a tool it can be. Would you be willing to share a quick testimonial on your experience that we can share with others? Just 2-3 sentences would be incredibly helpful for us to get the word out. Thank you.",
			donorAlertDefaultText: "A constituent assigned to you has volunteered by mentoring someone via <a href='{{ community.url }}'>{{ community.parameter2 }}</a>",
			requestFormWizardPage2: "A great question will get you great answers (and connections). Here’s a <a target='_blank' href='https://vimeo.com/577233028/1fa12ba1fe'>short video</a> on how to craft one.",
			requestFormWizardPage3: "Here's what advisors will receive. Need to make a revision? Simply click 'Back' and edit.",
			closeRequestDefaultMessage: "We are no longer accepting responses for this request."
		};
	},
	created: async function() {
		const dict = {
			custom: {
				formThankyou: {
					required: "Please enter request form thank you message"
				},
				closeRequestMessage: {
					required: "Please enter close request message"
				},
				snoozeMessage: {
					required: "Please enter message for snooze"
				},
				responseEngagementTip: {
					regex: "Please enter a valid URL"
				},
				advisorThankYou: {
					regex: "Please enter a valid URL"
				},
				memberThankYou: {
					regex: "Please enter a valid URL"
				},
				referralMessage: {
					required: "Please enter referral message."
				}
			}
		};
		this.$validator.localize('en', dict);
	},
	methods: {
		expandchannel(id) {
			const index = this.opened.indexOf(id);
			if (index > -1) {
				// this.opened.splice(index, 1)
			} else {
				this.opened.push(id)
			}
		},
		sanitizeInput(event) {
			return sanitizeInput(event)
		},
		sanitizeURL(event) {
			return sanitizeUrl(event)
		},
		sanitizeHtmlTemplate(event) {
			return sanitizeHtmlTemplate(event)
		},
		sanitizeActionFormTips(value) {
			return applyActionFormTipsSanitize(value);
		},
		addContent: async function (scope) {
			this.$validator.validateAll(scope).then(async community => {
				if (community) {
					this.content.feedbackRequestMessage = this.content.feedbackRequestMessage.trim() == '' ? this.feedbackRequestDefaultText : this.content.feedbackRequestMessage;
					this.content.donorAlertMessage = this.content.donorAlertMessage.trim() == '' ? this.donorAlertDefaultText : this.content.donorAlertMessage;
					this.content.requestFormWizardPage2 = this.content.requestFormWizardPage2.trim() == '' ? this.requestFormWizardPage2 : this.content.requestFormWizardPage2;
					this.content.requestFormWizardPage3 = this.content.requestFormWizardPage3.trim() == '' ? this.requestFormWizardPage3 : this.content.requestFormWizardPage3;
					this.content.invalidMemberMessage = this.content.invalidMemberMessage.trim() == '' ? "This community is for members only. Unfortunately we’re not able to confirm your membership. If you believe this is an error, please contact the administrator of this community at {{ community.email }}. We apologize for the inconvenience." : this.content.invalidMemberMessage;
					this.content.closeRequestMessage = this.content.closeRequestMessage.trim() == '' ? this.closeRequestDefaultMessage : this.content.closeRequestMessage;
					this.termsAndConditions = this.content.termsAndConditions;
					this.content.actionFormCallTips = this.content.actionFormCallTips.trim() == '' ? "" : this.content.actionFormCallTips;
					this.content.actionFormAdviceTips = this.content.actionFormAdviceTips.trim() == '' ? "" : this.content.actionFormAdviceTips;
					this.content.actionFormMeetingTips = this.content.actionFormMeetingTips.trim() == '' ? "" : this.content.actionFormMeetingTips;
					if (this.content.emailFooter.trim() == '') {
						this.content.emailFooter = `<table width="100%" border="0" cellspacing="0" cellpadding="0">
							<tr>
								<td align="center" valign="top" class="date2"
											style="font-family:'Roboto Slab', Georgia, 'Times New Roman', Times, serif;font-size:11px;line-height:17px;color:#CCCCCC;padding-left:50px; padding-right:50px;">
									<br />
									<a href="{{ landingPageURL }}" target="_blank" style="text-decoration:none;color:#000000;">Learn More</a>&nbsp;|&nbsp;
									<a href="{{ termsConditionsURL }}" target="_blank" style="text-decoration:none;color:#000000;">Terms Of Use [pdf]</a> &nbsp;|&nbsp;
									<a href="{{ unsubscribePageURL }}" target="_blank" style="text-decoration:none;color:#000000;">Opt Out</a>
								</td>
							</tr>
							<tr>
								<td align="center" valign="top" style="padding:30px;">
									<a href="#" target="_blank">
										<img src='{{ community.customSettings.organizationURL }}'alt="Powered by Protopia" width="66"
												height="auto" style="display:block;max-width:150px;height:auto;" border="0" />
									</a>
								</td>
							</tr>
							<tr>
								<td class="cmm_hide" style="line-height:1px;min-width:634px;background-color:#ffffff;">
									<img alt="" src="https://storage.googleapis.com/protopia/app/email/spacer.gif" height="1" width="634"
												style="max-height:1px; min-height:1px; display:block; width:634px; min-width:634px;" border="0" />
								</td>
							</tr>
						</table>`;
					}
					this.content.termsAndConditionsMessage = this.content.termsAndConditionsMessage.trim() == '' ? "Click here to indicate that you have read and agree to the terms presented in our Terms and Conditions agreement." : this.content.termsAndConditionsMessage;
					await this.api.put(`communities/${this.community_id}/update-content/`, this.content).then(community => {
						this.$emit("reload");
						this.saveContentText = "saved";
					});
				}
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/partials/community/__CommunityContentSection.vue